/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HonorsAssignmentIcon = /*#__PURE__*/ createSvgIcon(
  'HonorsAssignmentIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 9.938L8.604 11c-.07.056-.142.056-.219 0-.076-.056-.1-.125-.072-.208l.541-1.73-1.437-1.124c-.07-.056-.09-.125-.063-.209.028-.083.09-.125.188-.125H9.27l.541-1.708c.028-.083.09-.125.188-.125.097 0 .16.042.188.125l.541 1.708h1.73c.097 0 .16.042.187.125.028.083.007.153-.063.208l-1.437 1.125.541 1.73c.028.083.004.152-.072.208-.077.056-.15.056-.22 0L10 9.937zM10 18l-3.604.792a.702.702 0 01-.636-.146.72.72 0 01-.28-.584v-4.895c-.598-.514-1.077-1.202-1.438-2.063A6.683 6.683 0 013.5 8.5c0-1.806.632-3.34 1.896-4.604C6.66 2.632 8.194 2 10 2s3.34.632 4.604 1.896C15.868 5.16 16.5 6.694 16.5 8.5c0 .889-.167 1.76-.5 2.615-.333.854-.833 1.545-1.5 2.072v4.876a.72.72 0 01-.281.583.703.703 0 01-.636.146L10 18zm0-4.5c1.389 0 2.57-.486 3.542-1.458C14.514 11.069 15 9.889 15 8.5c0-1.389-.486-2.57-1.458-3.542C12.569 3.986 11.389 3.5 10 3.5c-1.389 0-2.57.486-3.542 1.458C5.486 5.931 5 7.111 5 8.5c0 1.389.486 2.57 1.458 3.542.973.972 2.153 1.458 3.542 1.458zm-3.02 3.625l3.02-.667 3 .667V14.25c-.458.25-.941.438-1.448.563A6.46 6.46 0 0110 15a6.954 6.954 0 01-1.563-.177c-.513-.118-1-.31-1.458-.573v2.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HonorsAssignmentIcon;
